<style scoped>
	.c-panel{margin: 0px; padding: 0px 20px;}
</style>

<template>
	<el-dialog
		v-if="m"
		title="课时修改"
		:visible.sync="isShow"
		width="400px"
		top="25vh"
		:append-to-body="true"
		:destroy-on-close="true"
		:close-on-click-modal="false"
		custom-class="full-dialog"
		>
		<div class="vue-box">
			<div class="c-panel">
				<!-- 参数栏 -->
				<br>
				<el-form size="mini">
					<el-form-item label="编号：" v-show="m.id!=0">
						<el-input v-model="m.id" disabled></el-input>
					</el-form-item>
					<el-form-item label="课时：">
						<el-input v-model="m.hour"></el-input>
					</el-form-item>
          <el-form-item label="描述：">
          <el-input
              type="textarea"
              :rows="2"
              placeholder="填写变更原因（家长可以看到），如1.充值20课时2.因为XX原因扣减1课时"
              v-model="m.des">
          </el-input>
          </el-form-item>
				</el-form>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="isShow = false">取 消</el-button>
			<el-button size="small" type="primary" @click="ok()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				isShow: false,
				id: 0,
				m: null,

			}
		},
		methods: {
			// 打开
			open: function(id) {
        this.id = id;
				this.isShow = true;
        this.m = this.create_m(id);

			},
			// 表单验证
			submit_check: function() {
				var m = this.m;
				var sa = this.sa;
				if(sa.isNull(m.id)) {
					return sa.error('学生ID不能为空');
				}
        if(sa.isNull(m.hour) || m.hour==0) {
          return sa.error('改动课时不能为空或0');
        }
        if(sa.isNull(m.des)) {
          return sa.error('修改描述，必须填写');
        }
				return 'ok';
			},
			// 提交
			ok: function() {
				// 表单验证
				if(this.submit_check() != 'ok') {
					return;
				}
				// 开始增加或修改
				let self = this;
					// id != 0 为修改
					this.sa.ajax('api/psdAdmin/stu/changeStudentHour', this.m, function(res){
            if(res.code == '0') {
              self.sa.alert('修改成功', function () {
                self.$parent.f5();	// 父视图刷新
                self.isShow = false;
              });
            }else{
              this.sa.error(res.msg || '修改失败');
            }
					});
			},
			// 创建一个空的model
			create_m: function(id) {
				return {
					id: id,
					hour:0,
          des:''
				}
			},
		},
		created: function(){
		}
	}
</script>
